import { useMemo } from "react";
import { get } from "lodash";
import nav from "../_nav";
import {
  buildPermissionMap,
  filterNavigationItems,
} from "./navigation-utils";

export default function usePermissionsNavigation(profile) {
  return useMemo(() => {
    const views = get(profile, "views", []);
    const permissionViews = buildPermissionMap(views);

    const navigation = {
      items: filterNavigationItems(nav.items, permissionViews),
    };

    return { permissionViews, navigation };
  }, [profile]);
}
